<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" class="col-lg-12">
    <form @submit.prevent="handleSubmit(saveShiftType)" class="justify-content-between col-lg-12 py-3">
      <div class="form-row align-items-center py-3">
        <TextInputField
            labelText="shiftnaam" class="form-group col-lg-6"
            v-model="shiftName"
            maxLength="20" required/>
        <ColorInputField
            labelText="shiftkleur" class="form-group col-md-6"
            required v-model="color"/>
      </div>

      <ValidationObserver tag="div" class="form-row align-items-center py-3">
        <TimeInputField
            class="form-group col-lg-6" v-model="startTime"
            labelText="startuur" required
            vid="startTime"/>
        <TimeInputField
            class="form-group col-lg-6" v-model="endTime"
            labelText="einduur" required
            :crossFieldRules="['notSame:@startTime']"/>
      </ValidationObserver>

      <div class="form-row col-12 mb-3 justify-content-center">
        <div class="custom-control custom-switch">
          <input
              type="checkbox" class="custom-control-input"
              id="pause" v-model="breakHoursShow"/>
          <label class="custom-control-label" for="pause">Vaste pauze-uren?</label>
        </div>
      </div>

      <ValidationObserver
          v-show="breakHoursShow"
          tag="div" class="form-row align-items-center py-3">
        <TimeInputField
            class="form-group col-lg-6" v-model="breakStartTime"
            labelText="pauze startuur" vid="breakStartTime"
            :crossFieldRules="['bothRequiredOrBothNot:@breakEndTime']"/>
        <TimeInputField
            class="form-group col-lg-6" v-model="breakEndTime"
            labelText="pauze einduur" vid="breakEndTime"
            :crossFieldRules="['bothRequiredOrBothNot:@breakStartTime|notSame:@breakStartTime']"/>
      </ValidationObserver>

      <div class="form-row align-items-center py-3">
        <div class="input-group col-6">
          <button
              type="submit" :disabled="invalid"
              class="btn-basic btn-green">
            Opslaan
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {mapActions} from "vuex";
import {ValidationObserver} from "vee-validate";
import TextInputField from "@/components/inputFields/TextInputField";
import TimeInputField from "@/components/inputFields/TimeInputField";
import ColorInputField from "@/components/inputFields/ColorInputField";

export default {
  name: "CreateShiftTypeComponent",
  components: {
    ColorInputField,
    TimeInputField,
    TextInputField,
    ValidationObserver
  },
  props: ['customerId'],
  data() {
    return {
      shiftName: "",
      color: "#FFFFFF",
      startTime: "",
      endTime: "",
      breakStartTime: "",
      breakEndTime: "",
      breakHoursShow: false,
    };
  },
  methods: {
    ...mapActions("administrationCustomer", ['createShiftType']),
    async saveShiftType() {
      const createShiftTypeDto = {
        name: this.shiftName,
        color: this.color,
        labourTime: {
          startTime: this.startTime,
          endTime: this.endTime
        }
      };
      if (this.breakHoursShow && this.breakStartTime && this.breakEndTime) {
        createShiftTypeDto["breakTime"] = {
          startTime: this.breakStartTime,
          endTime: this.breakEndTime,
        };
      }
      await this.createShiftType(createShiftTypeDto).then(() => {
        this.resetFields();
        this.$emit('shiftTypeAdded');
      });
    },
    resetFields() {
      this.shiftName = "";
      this.color = "#FFFFFF";
      this.startTime = "";
      this.endTime = "";
      this.breakStartTime = "";
      this.breakEndTime = "";
      this.breakHoursShow = false;
    },
  }
};
</script>

<style scoped>

</style>
